import type TranslateZ0Style from './type';

const translateZ0: TranslateZ0Style = {translateZ0: {transform: 'translateZ(0)'}};

export default translateZ0;
